module.exports = __webpack_public_path__ + "static/images/add-blue.a76c94606be516e47aceafeb92e247fd.svg";